import React from 'react';

import { Modal, Button, ModalFooter } from 'modules/ui/components';
import { RegularBase } from 'modules/ui/typography';

import { FormContainer } from './styledComponents';

type Props = {
  isOpen: boolean;
  closeModal: () => void;
  goToFileChoice: () => void;
  hasMultipleZonesError?: boolean;
  error?: string | null;
};

const ErrorModal: React.FC<Props> = ({
  isOpen,
  closeModal,
  goToFileChoice,
  hasMultipleZonesError,
  error,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      width={600}
      title="Upload GeoJSON with 1 inclusion zone"
      closeModal={closeModal}
    >
      <FormContainer>
        <RegularBase>
          {hasMultipleZonesError
            ? 'The file, although in the right GeoJSON format, contained more than 1 area and therefore was not processed.'
            : 'The selected file contained errors and was not processed successfully.'}
        </RegularBase>
        {error && (
          <>
            <br />
            <br />
            <code>{error}</code>
          </>
        )}
        <br />
        <br />
        <RegularBase>
          {hasMultipleZonesError
            ? 'Please check the file content and try again.'
            : 'Please check the format and try again.'}
        </RegularBase>
      </FormContainer>
      <ModalFooter>
        <Button isSecondary label="Back" clickHandler={goToFileChoice} />
        <Button label="Ok" clickHandler={closeModal} />
      </ModalFooter>
    </Modal>
  );
};

export default React.memo(ErrorModal);
